import { useEffect, useState, useRef, RefObject } from 'react';

export const useTextEllipsesTruncated = (): [RefObject<HTMLDivElement>, boolean] => {
  const targetRef = useRef<HTMLDivElement>(null);
  const [isTruncatedText, setIsTruncatedText] = useState<boolean>(false);
  useEffect(() => {
    if (targetRef?.current?.offsetWidth === undefined) {
      setIsTruncatedText(false);
    } else if (targetRef?.current?.offsetWidth < targetRef?.current?.scrollWidth) {
      setIsTruncatedText(true);
    } else {
      setIsTruncatedText(false);
    }
  }, [isTruncatedText]);
  return [targetRef, isTruncatedText];
};
